export enum TransferListSide {
	LEFT,
	RIGHT,
}
